import React, { useEffect } from 'react';
import { BookmarkContainer } from './styles';
import BookmarkIcon from 'components/Brand/Icons/Toolbox/BookmarkIcon';
import toggleBookmark from './toggleBookmark';
import { WithUserContext } from 'utils/UserContext';
import { WithBookmarkContext } from 'utils/BookmarkContext';
import mapBookmarkData from 'utils/mapBookmarkData';
import Cookies from 'js-cookie';

const ToolBoxBookmark = ({
  children,
  data,
  title,
  subTitle,
  type,
  url,
  image,
  color = 'white',
  userInfo,
  setUserInfo,
  openLoginModal,
  ...props
}) => {
  const mappedData = mapBookmarkData({ ...data, subTitle, title, image }, type, url);
  const filled =
    mappedData && userInfo?.bookmarks?.filter(x => x.url)?.some(x => x.url === mappedData.url);
  const tookboxCookie = 'ToolboxBookmark';

  useEffect(() => {
    if (userInfo && Cookies.get(tookboxCookie)) {
      const savedData = JSON.parse(Cookies.get(tookboxCookie));
      toggleBookmark(savedData.filled, savedData.data, userInfo, setUserInfo, openLoginModal);
      Cookies.remove(tookboxCookie);
    }
  }, [userInfo]);

  return (
    <BookmarkContainer color={color} {...props}>
      {children}
      {mappedData && (
        <BookmarkIcon
          color={color}
          filled={filled}
          onClick={e => {
            e.preventDefault();
            if (!userInfo) {
              if (openLoginModal) {
                Cookies.set(tookboxCookie, { filled: !filled, data: mappedData });
                openLoginModal();
              }
              return;
            }
            toggleBookmark(!filled, mappedData, userInfo, setUserInfo, openLoginModal);
          }}
        />
      )}
    </BookmarkContainer>
  );
};

export default WithBookmarkContext(WithUserContext(ToolBoxBookmark));
